import { Configuration, PopupRequest } from '@azure/msal-browser';

// Runtime config (injected by docker-entrypoint.sh) takes precedence over
// CRA build-time env vars so the same Docker image works in every environment.
declare global {
  interface Window {
    __env__?: {
      REACT_APP_AZURE_CLIENT_ID?: string;
      REACT_APP_AZURE_AUTHORITY_URL?: string;
      REACT_APP_API_SCOPE?: string;
    };
  }
}

const clientId =
  window.__env__?.REACT_APP_AZURE_CLIENT_ID ||
  process.env.REACT_APP_AZURE_CLIENT_ID ||
  '';

const authority =
  window.__env__?.REACT_APP_AZURE_AUTHORITY_URL ||
  process.env.REACT_APP_AZURE_AUTHORITY_URL ||
  '';

const apiScope =
  window.__env__?.REACT_APP_API_SCOPE ||
  process.env.REACT_APP_API_SCOPE ||
  '';

if (!clientId || !authority || !apiScope) {
  console.error(
    '[MSAL] Missing configuration. ' +
    'Set REACT_APP_AZURE_CLIENT_ID, REACT_APP_AZURE_AUTHORITY_URL, and REACT_APP_API_SCOPE ' +
    'as environment variables on the container.'
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri: `${globalThis.location.origin}/`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

export const apiRequest: PopupRequest = {
  scopes: [apiScope],
};
